// src/components/stripe/StripePaymentForm.jsx
import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function StripePaymentForm({ onResult }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });

    setLoading(false);
    onResult({
      status: result.paymentIntent?.status
    });
    return;
  };

  return (
    <form onSubmit={submitPayment}>
      <PaymentElement />

      <button
        type="submit"
        className="btn btn-primary w-100 mt-3"
        disabled={!stripe || loading}
      >
        {loading ? "Traitement…" : "Payer maintenant"}
      </button>
    </form>
  );
}
